import { Tooltip } from 'antd'
import React from 'react'

const ResendIntiveIcon = () => {
  return (
    <Tooltip title="Resend Invites">
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_19483_35753)">
    <rect x="2" y="1" width="38" height="38" rx="5" fill="#FBFAFF"/>
    <rect x="2.5" y="1.5" width="37" height="37" rx="4.5" stroke="#E3DEFF"/>
    <g clip-path="url(#clip0_19483_35753)">
    <path d="M11.8792 18.5214C11.5988 18.4423 11.3512 18.2755 11.1725 18.0453C10.9939 17.8152 10.8937 17.5339 10.8866 17.2426C10.8796 16.9514 10.966 16.6655 11.1332 16.427C11.3005 16.1884 11.5398 16.0098 11.816 15.9172L30.2144 9.91665C30.3349 9.87736 30.4639 9.87211 30.5873 9.90148C30.7106 9.93085 30.8234 9.9937 30.9133 10.0831C31.0031 10.1725 31.0666 10.285 31.0966 10.4081C31.1266 10.5313 31.122 10.6603 31.0834 10.7811L25.0875 29.1886C24.9953 29.4653 24.8167 29.7051 24.578 29.8728C24.3394 30.0404 24.0532 30.127 23.7616 30.1198C23.4701 30.1126 23.1885 30.012 22.9584 29.8328C22.7282 29.6537 22.5617 29.4054 22.4832 29.1245L20.4244 20.5711L11.8792 18.5214Z" stroke="#3249D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M30.9137 10.0817L20.4243 20.5711" stroke="#3249D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </g>
    <defs>
    <filter id="filter0_d_19483_35753" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19483_35753"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19483_35753" result="shape"/>
    </filter>
    <clipPath id="clip0_19483_35753">
    <rect width="22" height="22" fill="white" transform="translate(10 9)"/>
    </clipPath>
    </defs>
    </svg>
    </Tooltip>
  )
}

export default ResendIntiveIcon